import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a popup
 */
export default class PointOfInterestHotspot extends BaseHotspot {
  /**
   * Initialises an note hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'poi',
   *   options: {
   *     name: string,
   *     onEnter: boolean,
   *     activeDirections: [string] | null
   *     showEyeIcon: boolean,
   *     onlyStartingImage: boolean,
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    if (this.player.mode === "editor") {
      this.loadTexture({
        url: `${window.location.origin}/tour/assets/hotspots/poi.png`,
      });
    } else {
      this.setInactive();
      this._hasTooltip = false;
      this._tooltip = undefined;

      const onlyStartingImage = config.options.onlyStartingImage;
      const onStartingImage =
        this.player.config.startingImage === this.player.activeScene;
      const playOnceAtTourStart =
        onlyStartingImage &&
        onStartingImage &&
        !this.player.hasPlayedInitialLookAt &&
        this.player.isInitialTourLoad;
      const matchesActiveDirections =
        !config.options.activeDirections ||
        config.options.activeDirections.includes(this.player.previousScene);

      if (
        config.options.onEnter &&
        (onlyStartingImage ? playOnceAtTourStart : matchesActiveDirections)
      ) {
        if (this.player.isSpinning) return;
        this.player.waitForPosterPageDisappear().then(() => {
          this.player.setLoadingPOIHotspot?.(true);
          setTimeout(() => {
            if (onlyStartingImage) {
              this.player.hasPlayedInitialLookAt = true;
            }
            this.lookAtMe(config.options.name, config.options);
          }, 1000);
          setTimeout(() => {
            this.player.setLoadingPOIHotspot?.(false);
          }, 1500);
        });
      }
    }

    this._config = config;
  }
}
